import { Fragment } from 'react';

// material-ui
import { Divider, ListItemAvatar, ListItemButton, ListItemSecondaryAction, ListItemText, Stack, Typography } from '@mui/material';

// project imports

// assets
import AssetLogo from './AssetLogo';
import { CaretDownOutlined } from '@ant-design/icons';
import IconButton from '../components/@extended/IconButton';

export interface AssetListOptionProps {
  logo: string | null;
  logo2?: string | null;
  name: string;
  type: string;
  onClick?: any;
  showEditAction?: boolean | undefined;
  isPublic?: boolean;
}

function AssetListButtonOption({ showEditAction, ...props }: AssetListOptionProps) {
  return (
    <Fragment>
      <ListItemButton {...props}>
        <ListItemAvatar sx={{ minWidth: props.logo2 ? 62 : 42 }}>
          {props.logo2 ? (
            <Stack direction={'row'} spacing={-1.5}>
              <AssetLogo logo={props.logo} name={props.name} size={'sm'} />
              <AssetLogo logo={props.logo2} name={props.name} size={'sm'} />
            </Stack>
          ) : (
            <AssetLogo logo={props.logo} name={props.name} size={'sm'} isPublic={props.isPublic} />
          )}
        </ListItemAvatar>
        <ListItemText
          primary={
            <Stack component="span" direction="column" alignItems="left" justifyContent="space-between" spacing={0.2}>
              <Typography component="span" color="textSecondary" variant="caption">
                {props.type}
              </Typography>
              <Typography
                variant="body2"
                color="inherit"
                sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}
              >
                {props.name}
              </Typography>
            </Stack>
          }
        />
        {!!showEditAction && (
          <ListItemSecondaryAction>
            <IconButton disabled={true} edge="end" color="secondary" aria-label="Click to edit">
              <CaretDownOutlined />
            </IconButton>
          </ListItemSecondaryAction>
        )}
      </ListItemButton>
      <Divider />
    </Fragment>
  );
}

export default AssetListButtonOption;